module.exports = __webpack_public_path__ + "img/sp3.6f2e4ebd.svg";